import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_NO_DEMO_ILO2 = {
  title: "Alarm categorization - ILO AI \nML predicts alarm \ncategorization",
  subtitle: "Network operations demo",
  text: '<span style="font-weight:bold">Fast resolution time</span> — proactively identifying \nthe category of the issue.',
  label: { iconPath: "start.png", text: "ILO AI" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_209"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_207"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO2/ILO2_demo_screens_base.png",
  rightSideVideo: "ILO/ILO2/INF_CMT_827.23_Network Demo_Part 5_R1.mp4",
  pageNumber: "ILO_208",
};

export default DATA_NO_DEMO_ILO2;
